import React from 'react';
import { Grid } from '@mui/material';
import {
  DateInput,
  NumberInput,
  required,
  SelectInput,
  TextInput,
} from 'react-admin';
import currencies from '../../../../constants/currencies';
import paymentDetailsMethodChoices from '../constants/paymentDetailsMethodChoices';

const InvoiceProductInformation = () => (
  <Grid container spacing={6}>
    <DateInput
      source="productInformation.invoiceDate"
      label="invoice date"
      validate={required()}
    />
    <DateInput
      source="productInformation.dueDate"
      label="due date"
      validate={required()}
    />
    <SelectInput
      source="productInformation.currency"
      label="Currency"
      choices={currencies.map((currency) => ({
        id: currency,
        name: currency,
      }))}
      validate={required()}
    />
    <NumberInput
      source="productInformation.invoiceAmount"
      label="Invoice amount"
      validate={required()}
    />
    <NumberInput
      source="productInformation.vatAmount"
      type="number"
      label="VAT amount"
    />
    <TextInput
      source="productInformation.invoiceNumber"
      label="Invoice Number"
    />
    <TextInput
      source="productInformation.customerNumber"
      label="Customer Number"
    />
    <TextInput
      source="productInformation.paymentDetails.accountNumber"
      label="Payment account number"
    />
    <TextInput
      source="productInformation.paymentDetails.reference"
      label="Payment reference"
    />
    <SelectInput
      source="productInformation.paymentDetails.method"
      label="Payment method"
      choices={paymentDetailsMethodChoices}
    />
  </Grid>
);

export default InvoiceProductInformation;
